export const transparencia_item = [
    {
        "transparencia_item_nombre" : "48 Rubros",
        "transparencia_item_url" : "/Transparencia/Rubros"
    },
    {
        "transparencia_item_nombre" : "Contratos de obra 2020",
        "transparencia_item_url" : "/Transparencia/Contratos"
    },
      {
        "transparencia_item_nombre" : "Convenios",
        "transparencia_item_url" : "/Transparencia/Convenios"
      },
      {
        "transparencia_item_nombre" : "Documentos Normativos",
        "transparencia_item_url" : "/Transparencia/Normativos"
      },
      {
        "transparencia_item_nombre" : "Programa Anual de Desarrollo Archivístico",
        "transparencia_item_url" : "/Transparencia/Pada"
      },
      {
        "transparencia_item_nombre" : "Programa de Investigación e Información para el Desarrollo Social",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/misc/PIIDS.pdf"
      },
];